import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getSubscriptionStatus } from '../services/subscriptions';
import { RootState } from '../store/store';

interface SubscriptionProviderProps {
  children: React.ReactNode;
}

const SubscriptionProvider = ({ children }: SubscriptionProviderProps) => {
  const currentUser = useSelector((state: RootState) => state.user.profile);

  useEffect(() => {
    if (!currentUser) return;

    getSubscriptionStatus();
  }, [currentUser]);

  return <>{children}</>;
};

export default SubscriptionProvider;
